<template>
    <div class="animated fadeIn">
      <mensagem></mensagem>
      <b-row v-if="!loadingItens && items.length <= 0">
        <b-col lg="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i> <strong> Fechamentos </strong>
              <div class="card-header-actions">
              </div>
            </div>
            <div>
              <b-jumbotron header="Nenhum fechamento registrado" >
  
              </b-jumbotron>
            </div>
          </b-card>
        </b-col>
      </b-row>
          <b-row>
        <b-col lg="12">
            <grid-fechamento
              :table-data="items" 
              :total-de-paginas="totalDePaginas"
              :action-buttom="true"
              :loading="loadingItens"
              :fields="fields" 
              caption=" Fechamentos"
              @paginacao="paginacao"
              @imprimir="imprimirRegistro">
            </grid-fechamento>
        </b-col>
      </b-row>

      <b-modal 
        title="Impressão do período"
        class="modal-danger" 
        v-model="openModalFinalizar" 
        hide-footer
        :no-close-on-backdrop=true>

          <div class="modalZag">
            <div class="zig-zag-wrapper">
              <div class="zig-zag">           
    <pre style="background-color: rgb(240, 240, 177); font-size: 15px;" >
      <strong>
        <span style="display: block; text-align: center;">
{{arquivoImprimir.conta.nomeFantasia }}
CNPJ: {{formatarCNPJ(arquivoImprimir.conta.cnpj) }}
</span>
========================================
Cliente: {{arquivoImprimir.cliente.nomeCliente }}
CNPJ: {{formatarCNPJ(arquivoImprimir.cliente.cnpj) }}
<small>{{arquivoImprimir.usuario.padEnd(32)}}{{ arquivoImprimir.dataFechamento }}</small>
========================================
DESCRIÇÃO         QUANTIDADE     PESO Kg
----------------------------------------
<span v-for="centroCusto in arquivoImprimir.centroDeCusto" style="display: block; margin-bottom: -20px; margin-top: -20px;">
{{ centroCusto.descricao.padEnd(22) }}{{ centroCusto.quantidade.toString().padEnd(12) }}{{ realBRLocale.format(centroCusto.valor.toString())}}
</span>
========================================
QTD TOTAL DE PESAGEM              {{calcularTotalQuantidade()}}
PESO TOTAL Kg                     {{calcularTotalPeso()}}
========================================
</strong>
  </pre>
            </div>
            </div>
      </div>
          
        <div class="d-flex flex-column">
          <div class="btn-group" >
            
                <b-button variant="success" @click="confirmaFinalizar()" title="Imprimir" style="margin-top: 5%;">
                    <span>Imprimir</span>
                  </b-button>
                  <b-button variant="danger" @click="fecharModalFinalizar()" title="Fechar" style="margin-top: 5%;">
                    <span>Fechar</span>
                </b-button>
            </div>
        </div>
      </b-modal>
    </div>
  </template>
  
  <script>
  import GridFechamento from '@/views/Fechamento/GridFechamento'
  import Mensagem from '@/base/components/Mensagem'
  import { isElectron } from  '../../shared/isElectron';
  
  export default {
    name: 'fechamento',
    components: {
      GridFechamento,
      Mensagem
    },
    data(){
      return {
        items: [],
        loadingItens: false,
        totalDePaginas: 1,
        openModalFinalizar:false,
        fields: [
        { key: "dataFechamento", label: "Data de fechamento", sortable: true },
        { key: "quantidade", label: "Quantidade", sortable: true },
        { key: "total", label: "Peso total Kg", sortable: true },
        { key: 'acoes', label: "Ações", sortable: false, thClass: "center, wd-120-px"}
        ],
        arquivoImprimir:
        {
          conta:{
            nomeFantasia:null,
            cnpj:""
          },
          cliente:{
            nomeCliente:null,
            cnpj:""
          },
          centroDeCusto:[],
          usuario:"",
          dataFechamento:""
        },
        dataAtual: new Date().toLocaleDateString("pt-BR", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'  }),
        realBRLocale: Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }),
        
      }
    },
    beforeMount(){
      this.getGridData(this.$route.params.id)
    },
    methods: {
      formatarData(date){
        return date.toLocaleDateString("pt-BR", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'  })
      },
      imprimirRegistro(registro){
        
        var vm = this
        var viewModel = {
            ContaId: vm.$store.getters.getAutenticacao.contaId,
            ClienteId: vm.$store.getters.getAutenticacao.clienteId,
            UsuarioId: vm.$store.getters.getAutenticacao.usuarioId,
            FechamentoId: registro.fechamentoId
        }
        //console.log(viewModel)

        this.$http({url: '/pesagem/visualiza-rol', data: viewModel, method: 'POST'  })
          .then(response => {
            this.arquivoImprimir = response.data
            this.openModalFinalizar = true
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            vm.$router.go()
        })
      },
      getGridData(pagina){
         var vm = this
         vm.loadingItens = true
        this.$http({url: '/pesagem/fechamentos/' +  pagina + "/" + vm.$store.getters.getAutenticacao.contaId + "/" + vm.$store.getters.getAutenticacao.usuarioId, method: 'GET' })
          .then(response => {
            vm.loadingItens=false
            vm.items =  response.data.listagem
            vm.totalDePaginas =response.data.paginas
  
        })
        .catch(err => {
            alert(err.message)
        })
      },    
      paginacao(ev){
        this.getGridData(ev)
      },
      async confirmaFinalizar(){
        const htmlContent = document.querySelector(".zig-zag").innerHTML;

        try {
          if (isElectron) {
          const { ipcRenderer } = await import('electron');
          await ipcRenderer.invoke("printContent", htmlContent);
          console.log("Impressão iniciada com sucesso!");
          }else {
        // Criar um elemento temporário para renderizar o HTML
            const tempContainer = document.createElement("div");
            tempContainer.innerHTML = htmlContent;

            // Abrir a janela de impressão para o elemento temporário
            const printWindow = window.open('', '_blank');
            printWindow.document.body.appendChild(tempContainer);

            // Esperar um curto período para garantir que o conteúdo seja renderizado
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Iniciar a impressão
            printWindow.print();
            console.log("Impressão iniciada com sucesso!");
          }
        } catch (error) {
          console.error("Erro ao iniciar a impressão:", error);
        }
      },
      fecharModalFinalizar(){
        this.openModalFinalizar = false
      },
      formatarCNPJ(cnpj) {
      // Lógica para formatar o CNPJ com a máscara
      const cnpjFormatado = cnpj.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      );
      return cnpjFormatado;
        },
        calcularTotalQuantidade() {
        let totalQuantidade = 0;
        for (const centroCusto of this.arquivoImprimir.centroDeCusto) {
            totalQuantidade += centroCusto.quantidade;
        }
        return totalQuantidade;
        },
        calcularTotalPeso() {
        let totalPeso = 0;
        for (const centroCusto of this.arquivoImprimir.centroDeCusto) {
            totalPeso += centroCusto.valor;
        }
        return this.realBRLocale.format(totalPeso);
        },
    },
  }
  </script>
  <style scoped>
  .zig-zag{
justify-content: center;
align-items: center;
margin: 0;
}
  .zig-zag:before {
    display: block;
    content: "";
    width: 100%;
    height: 20px;
    background: linear-gradient(45deg, rgb(240, 240, 177) 25%, transparent 25%), linear-gradient(-45deg, rgb(240, 240, 177) 25%, transparent 25%);
    background-size: 20px 20px;
    top: -18px;
    left: 0;

}
.zig-zag:after {
    display: block;
    content: "";
    width: 100%;
    height: 20px;
    background: linear-gradient(135deg, rgb(240, 240, 177) 25%, transparent 25%), linear-gradient(-135deg, rgb(240, 240, 177) 25%, transparent 25%);
    background-size: 20px 22px;
    background-position: -50px;
    margin-top: -17px;
    left: 0;

}
.modalZag{
  background-color: white;
  box-shadow: -10 0 5px rgba(0, 0, 0, 0.5);

}
.modalZag pre {
    text-align: left;
  }
  .zig-zag-wrapper {
    display: flex;
    justify-content: center;
  }
    </style>